import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { Card, CardHeader, CardText } from 'material-ui/Card';

import DetailView from '../Common/DetailView';

import Gravatar from 'react-gravatar';
import IconPerson from 'material-ui/svg-icons/action/perm-identity';

import UserStore from '../../stores/UserStore';
import UserActions from '../../actions/UserActionCreator';

import EventActions from '../../actions/EventActionCreator';
import EventStore from '../../stores/EventStore';

import buildContextMenu from '../Common/BuildContextMenu';
import { formatName } from '../../utils/StringUtils';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import { getISODateLimits } from '../../utils/Date';
import EventWrapper from '../Event/EventWrapper';
import EventDialog from '../Event/EventDialog';
import EventDialogCreate from '../Event/EventDialogCreate';
import { DateStyles } from '../../constants/CentricConstants';

import 'react-big-calendar/lib/css/react-big-calendar.css';
import ROLES from '../../constants/Roles';
import { withId } from '../Common/Decorators';

const localizer = BigCalendar.momentLocalizer(moment);


const style = {
    avatar: {
        borderRadius: '50%',
        height: '32px',
        width: '32px',
    }
};

const formats = {

};

class UserCalendar extends Component {

    constructor() {
        super(...arguments);

        this.state = {
            details: {
                id: '',
                title: '',
                firstName: '',
                lastName: '',
                initials: '',
                dateOfBirth: '',
                jobRole: '',
                username: '',
                email: '',
                visits: '',
                lastLogin : '',
            },
            events: [],
            actions: [],
            menuItems: [
                {
                    link: '/dashboard/user/' + this.props.id ,
                    icon: <IconPerson />,
                    label: 'User profile',
                },
            ],
            links: {
                back: '/dashboard/user/' + this.props.id,
                edit: '',
            },
            newEventDialog: {}
        };
    }

    componentWillMount() {
        UserStore.addChangeListener(this.onChange);
        UserActions.getById(this.props.id);

        this.eventListener = EventStore.addListener(this.onEventsChange);
        EventActions.listByUser(this.props.id, getISODateLimits());

        this.setState({actions: buildContextMenu(this.state.menuItems, this.context.auth)});
    }

    componentDidMount() {
        this.onChange = this.onChange.bind(this);
        this.onEventsChange = this.onEventsChange.bind(this);
        this.eventPropGetter = this.eventPropGetter.bind(this);
        this.onNavigate = this.onNavigate.bind(this);
        this.onSelectEvent = this.onSelectEvent.bind(this);
        this.convertEvent = this.convertEvent.bind(this);
        this.createEvent = this.createEvent.bind(this);
        this.onSelectSlot = this.onSelectSlot.bind(this);
    }

    componentWillUnmount() {
        UserStore.removeChangeListener(this.onChange);
        this.eventListener.remove();
    }

    render () {

        const infoLink = `/dashboard/user/${this.state.details.id}`;
        const scrollToTime = new Date();
        scrollToTime.setHours(6);

        let avatarIcon = (
            <Link
                to={infoLink}
            >
                <Gravatar
                    email={this.state.details.email}
                    default='https://cdn.premierit.com/images/icons/contact.png'
                    size={50}
                    style={style.avatar}
                />
            </Link>
        );

        return(
            <DetailView
                title=''
                backButton={true}
                backTo={null}
                actions={this.state.actions}
            >
                <div className="cent-cards">
                    <Card className="cent-card">
                        <CardHeader
                            title={formatName(this.state.details)}
                            subtitle="Calendar"
                            avatar={avatarIcon}
                        />
                        <CardText className="cent-card-calendar">
                            <BigCalendar
                                localizer={localizer}
                                popup
                                popupOffset={20}
                                formats={formats}
                                views={[ 'month', 'week', 'day' ]}
                                selectable={this.props.id === this.context.auth.identity.id}
                                defaultView='month'
                                events={this.state.events}
                                eventPropGetter={this.eventPropGetter}
                                defaultDate={new Date()}
                                onSelectSlot={this.onSelectSlot}
                                onNavigate={this.onNavigate}
                                components={{eventWrapper: EventWrapper}}
                                scrollToTime={scrollToTime}
                            />
                        </CardText>
                    </Card>
                </div>
                <EventDialog
                    event={this.state.selectedEvent}
                    onClose={() => this.onSelectEvent()}
                    editLink={(ROLES.ADMIN && this.state.selectedEvent && `/dashboard/event/${this.state.selectedEvent.id}/edit`) || null}
                />
                { this.state.newEventDialog.open && (
                    <EventDialogCreate
                        open
                        nameRequired
                        title="New Event"
                        start={this.state.newEventDialog.start}
                        end={this.state.newEventDialog.end}
                        eventDates={this.state.newEventDialog.eventDates}
                        onSave={this.createEvent}
                        onClose={() => this.setState({newEventDialog: {open: false}})}
                    />
                )}
            </DetailView>
        );
    }

    onChange(){
        const details = UserStore.getById(this.props.id);
        if (details !== undefined) {
            this.setState({details: details});
        }
    }

    convertEvent(event) {
        const eventData = {
            id:    event.id,
            start: new Date(event.timeStart),
            end:   new Date(event.timeEnd),
            title: event.name,
            url:   `/dashboard/event/${event.id}`,
            attendanceStatus: event.status,
            selectAction: () => this.onSelectEvent(event.id)
        };
        if (eventData.start.toLocaleTimeString() === "00:00:00" && eventData.end.toLocaleTimeString() === "00:00:00") {
            eventData.allDay = true;
        }
        return eventData;
    }

    onEventsChange() {
        const events = EventStore.getAvailable();
        if (events !== undefined) {
            this.setState({events: events.map(this.convertEvent)});
        }
    }

    onSelectEvent(eventId) {
        this.setState({selectedEvent: (!!eventId && EventStore.getById(eventId)) || null});
    }

    createEvent(data) {
        data.timeStart = data.timeStart.toString().replace(/\s\([^)]+\)/, '');
        data.timeEnd = data.timeEnd.toString().replace(/\s\([^)]+\)/, '');
        data.description = '';
        data.periodic = false;
        data.visibility = data.private ? 'private' : 'public';

        EventActions.save(data);
        this.setState({newEventDialog: {open: false}});
    }
    
    onNavigate(date, view) {
        EventActions.listByUser(this.props.id, getISODateLimits(date, view));
    }

    eventPropGetter(event) {
        let prop = {};
        if (event.attendanceStatus === 'attending' || event.attendanceStatus === 'attended') {
            prop.className = 'cent-event-attendance';
        } else {
            prop.className = 'cent-event';
        }
        return prop;
    }
    
    onSelectSlot({start, end}) {
        const startDate = start.toLocaleString('en-GB', DateStyles.shortWeekday);
        const endDate = end.toLocaleString('en-GB', DateStyles.shortWeekday);

        this.setState({
            newEventDialog: {
                start,
                end,
                open: true,
                eventDates: startDate === endDate ? startDate : `${startDate} - ${endDate}`
            }
        });
    }

}

UserCalendar.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default withId(UserCalendar);
